export type GameData = {
  general: {
    possibleScores: number[];
    hintReduction: number;
    gameUrl: string;
    startGameLayerId: number;
    viewerConfigName: string;
    highScoreTreshold: number;
    mediumScoreTreshold: number;
    randomQuestionsPerGame: number;
  }
  themes: Theme[],
  questions: Question[]
}

/**
 * Single source of truth for {@link GameData.general} fallbacks. Applied once
 * when the resource loads (see `ResourcesService.gameData`)
 */
export const GAME_DATA_GENERAL_DEFAULTS: Required<GameData['general']> = {
  possibleScores: [],
  hintReduction: 0,
  gameUrl: '',
  startGameLayerId: 0,
  viewerConfigName: '',
  highScoreTreshold: 800,
  mediumScoreTreshold: 400,
  randomQuestionsPerGame: 5
};

export type Theme = {
  id: number | null,
  name: string,
  imageURL: {
    url: string,
    alt: string,
  },
  isActive: boolean,
}

export type Question = {
  themeId: number;
  questionHeader: string;
  question: string;
  gameSetting: {
    gameLayer: number;
    featureIdKey: string;
    featureIdCorrectValue: string | number;
    featureNameKey: string;
  }
  answerDescription: string[];
  answerLayerId: number;
  answerLinkUrl: string;
  hint: string;
}
